import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const LABELS_FR = {
    count: 'Nombre'
};

const HorizontalBarChart = ({ data, title, dataKey, nameKey }) => {
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            margin: '10px',
            flex: 1
        }}>
            <h3 style={{ marginBottom: '20px', color: '#333' }}>{title}</h3>
            <ResponsiveContainer width="100%" height={Math.max(300, data.length * 35)}>
                <BarChart data={data} layout="vertical" margin={{ left: 100 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis type="category" dataKey={nameKey} width={150} />
                    <Tooltip formatter={(value, name) => [value, LABELS_FR[name] || name]} />
                    <Bar dataKey={dataKey} fill="#e74c3c" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default HorizontalBarChart;